import { create } from 'zustand';
import api from '../api/axios.js';

export const useAuthStore = create((set, get) => ({
  user: null,
  accessToken: null,
  tenant: null,
  onboarding: null,

  setToken: (token) => set({ accessToken: token }),
  setTenant: (tenant) => set({ tenant }),
  clearSession: () => set({ accessToken: null, user: null, tenant: null, onboarding: null }),

  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    set({ accessToken: data.accessToken, user: data.user, tenant: data.tenant || null, onboarding: data.onboarding || null });
    return data;
  },

  signup: async (payload) => {
    const { data } = await api.post('/auth/signup', payload);
    set({ accessToken: data.accessToken, user: data.user, tenant: data.tenant || null, onboarding: data.onboarding || null });
    return data;
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch {}
    get().clearSession();
  },

  fetchMe: async () => {
    try {
      if (!get().accessToken) {
        const { data: refreshed } = await api.post('/auth/refresh');
        set({
          accessToken: refreshed.accessToken,
          ...(refreshed.user && { user: refreshed.user }),
          ...(refreshed.tenant !== undefined && { tenant: refreshed.tenant || null }),
          ...(refreshed.onboarding !== undefined && { onboarding: refreshed.onboarding || null }),
        });
        if (refreshed.user) return refreshed;
      }

      const { data } = await api.get('/auth/me');
      set({ user: data.user, tenant: data.tenant || null, onboarding: data.onboarding || null });
      return data;
    } catch {
      get().clearSession();
      return null;
    }
  },

  isAuthenticated: () => !!get().accessToken,
}));
